module.exports = __webpack_public_path__ + "img/run6.7ac8ad4c.png";